package com.eladfinish.bible.contest.screens.lexicographicalSort

import androidx.compose.material3.SnackbarDuration
import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters
import dev.icerock.moko.resources.StringResource
import kotlinx.collections.immutable.ImmutableList

@Immutable
data class LexicographicalSortState(
    val bookNames: ImmutableList<String>,
    val selectedBookIndex: Int, // 1-based
    val selectedChapterIndex: Int, // 1-based
    val numberOfChaptersInSelectedBook: Int,
    val selectedOutputChapters: OutputChapters,
    val versesInTable: Int,
    val dialogState: DialogState,
) : StateKt {

    val isCreateTableEnabled
        get() = versesInTable > 0

    @Stable
    sealed class DialogState {
        data object None : DialogState()
        data class PremiumRequired(val message: String) : DialogState()
    }
}

sealed interface LexicographicalSortAction : ActionKt {
    data class BookSelected(val bookIndex: Int) : LexicographicalSortAction
    data class ChapterSelected(val chapterIndex: Int) : LexicographicalSortAction
    data class OutputChaptersSelected(val outputChapters: OutputChapters) : LexicographicalSortAction
    data object GenerateClicked : LexicographicalSortAction
    data object DismissDialog : LexicographicalSortAction
}

sealed interface LexicographicalSortEffect : EffectKt {
    data class ShowToastStringResource(
        val resource: StringResource,
        val snackbarDuration: SnackbarDuration,
    ) : LexicographicalSortEffect

    data class NavigateToPdfViewer(
        val bookIndex: Int,
        val chapterIndex: Int,
        val outputChaptersOrdinal: Int,
    ) : LexicographicalSortEffect
}
